"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useImpactRadius = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _jsSha = _interopRequireDefault(require("js-sha1"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _actions = require("../actions");

var _utils = require("../utils");

var _useWindowData3 = _interopRequireDefault(require("./useWindowData"));

var identified = false;
var initialized = false;

var useImpactRadius = function useImpactRadius(profile) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _redux.bindActionCreators)(_actions.telemetryActions, dispatch);
  }, [dispatch]),
      getAttribution = _useMemo.getAttribution;

  var _useWindowData = (0, _useWindowData3["default"])('ire'),
      _useWindowData2 = (0, _slicedToArray2["default"])(_useWindowData, 2),
      ireLoaded = _useWindowData2[0],
      ireRef = _useWindowData2[1];

  var identify = (0, _react.useCallback)(function (identityUuid, email) {
    (0, _utils.log)('Impact radius identify.');

    if (ireRef.current) {
      ireRef.current('identify', {
        customerId: identityUuid || '',
        customerEmail: email ? (0, _jsSha["default"])(email) : ''
      });
      initialized = true;
    } else {
      (0, _utils.log)("Impact radius called but not loaded", _utils.LEVELS.ERROR);
    }

    if (identityUuid && email) {
      identified = true;
    }
  }, [ireRef]);
  (0, _react.useEffect)(function () {
    if (ireLoaded) {
      if (!identified && profile.uuid && profile.email) {
        identify(profile.uuid, profile.email);
      }

      if (!initialized) identify();
    }
  }, [identify, profile, ireLoaded]);
  var track = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
      var appUuid, identityUuid, email, impactRadiusId, event, product, data, _paramsToObj, _paramsToObj$irclicki, irclickid;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              appUuid = _ref.appUuid, identityUuid = _ref.identityUuid, email = _ref.email, impactRadiusId = _ref.impactRadiusId, event = _ref.event, product = _ref.product;
              if (!identified) identify(identityUuid, email);
              _context.next = 4;
              return getAttribution({
                appUuid: appUuid,
                event: event,
                product: product
              });

            case 4:
              data = _context.sent;
              _paramsToObj = (0, _utils.paramsToObj)(data.queryString || ''), _paramsToObj$irclicki = _paramsToObj.irclickid, irclickid = _paramsToObj$irclicki === void 0 ? '' : _paramsToObj$irclicki;

              if (appUuid && identityUuid) {
                if (ireRef.current) {
                  (0, _utils.log)("Impact radius trackConversion ".concat(impactRadiusId, ", irclickid: ").concat(irclickid));
                  ireRef.current('trackConversion', impactRadiusId, {
                    orderId: appUuid,
                    customerId: identityUuid,
                    customerEmail: email ? (0, _jsSha["default"])(email) : '',
                    clickId: irclickid
                  });
                }
              } else {
                (0, _utils.log)("Impact radius trackConversion missing param clickId: ".concat(irclickid, " appUuid: ").concat(appUuid, " identityUuid: ").concat(identityUuid), _utils.LEVELS.ERROR);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [getAttribution, identify, ireRef]);
  return {
    track: track,
    identify: identify
  };
};

exports.useImpactRadius = useImpactRadius;
var _default = useImpactRadius;
exports["default"] = _default;